import { Id } from '@api/models/types';
import useQuery, { Variables } from '@utils/useQuery';
import moment from 'moment';

import { IntervalTypes, PerformSegmentBy } from '../../types';
import { requestPerformanceData } from '../actions';

type QueryProps = {
    start: string | Date;
    end: string | Date;
    vehicleIds?: Id[];
    driverIds?: Id[];
    segmentBy: Exclude<PerformSegmentBy, PerformSegmentBy.interval>;
};
type IntervalQueryProps = Omit<QueryProps, 'segmentBy'> & {
    segmentBy: PerformSegmentBy.interval;
    intervalType: IntervalTypes;
};

export const makeQuery =
    (attributes: string[], includes: string[] = []) =>
    (queryProps: QueryProps | IntervalQueryProps) => {
        const { start, end, vehicleIds = [], driverIds = [], segmentBy } = queryProps;
        return {
            from: moment(start).toDate(),
            to: moment(end).toDate(),
            driver_ids: driverIds,
            vehicle_ids: vehicleIds,
            segment_by: segmentBy,
            ...(queryProps.segmentBy === PerformSegmentBy.interval
                ? { interval_type: queryProps.intervalType }
                : {}),
            attributes,
            includes,
        };
    };

const usePerformData = (
    attributes: string[],
    {
        variables,
        selector,
        debounced,
        shouldMakeRequest,
    }: {
        variables: Variables;
        selector?: any;
        debounced?: boolean;
        shouldMakeRequest?: boolean;
    },
    includes: string[] | never[] = [],
) =>
    useQuery(makeQuery(attributes, includes), {
        endPoint: requestPerformanceData,
        variables,
        selector,
        debounced,
        shouldMakeRequest,
    });

export default usePerformData;
